import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames/bind';
import VerificationCode from 'react-code-input';
import CircularLoader from '../../../shared/components/CircularLoader/CircularLoader';
import styles from './licenceActivation.module.scss';

const conditionalStyles = classNames.bind(styles);

export default memo(function LicenceActivation(props) {
    const { t } = useTranslation('wizard');

    const handleCodeChange = code => {
        if (code.length === 6) {
            props.activateDenwaNanoRequest(code);
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.messageContainer}>
                <span>
                    {t('ACTIVATION_CODE_SENT')}&nbsp;
                    <strong>{props.alternativeEmail || props.companyEmail}</strong>.&nbsp;
                    {t('CHECK_SPAM_FOLDER')}
                </span>
                <br />
                <br />
                <span>{t('OPTIONAL_RESEND')}</span>
            </div>
            <div className={styles.verificationCodeLocation}>
                <div className={styles.verificationCodeContainer}>
                    <VerificationCode
                        fields={6}
                        className={conditionalStyles({
                            verificationCode: !props.activationError,
                            verificationCodeSuccess: props.activated,
                            verificationCodeError: props.activationError
                        })}
                        disabled={props.isActivating || props.activated}
                        inputMode="numeric"
                        onChange={handleCodeChange}
                        value={props.activationCode.toString()}
                    />
                    {props.isActivating && <CircularLoader size={24} />}
                </div>
                {props.activated && <span className={styles.verificationMessage}>{t('CORRECT_ACTIVATION_CODE')}</span>}
                {props.activationError && <span className={styles.verificationMessage}>{t('INCORRECT_ACTIVATION_CODE')}</span>}
            </div>
        </div>
    );
}, (prevProps, nextProps) =>
        prevProps.activated === nextProps.activated &&
        prevProps.activationError === nextProps.activationError &&
        prevProps.alternativeEmail === nextProps.alternativeEmail &&
        prevProps.companyEmail === nextProps.companyEmail &&
        prevProps.isActivating === nextProps.isActivating &&
        prevProps.activationCode === nextProps.activationCode &&
        prevProps.activateDenwaNanoRequest === nextProps.activateDenwaNanoRequest
);
